export const convertMoney = (price: number) => {
  return price.toLocaleString('ko-KR');
};
